import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import ContentCard from "src/components/Shared/ContentCard";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import HorizontalLinearProgressBar from "src/components/ProgressBar/HorizontalLinearProgressBar";

const OnboardingError = () => {
  const navigate = useNavigate();
  const handleToSystemOnboarding = () => {
    navigate("/onboarding/system");
  };

  return (
    <>
      <Stack alignItems={"center"} mt={50} p={5}>
        <Stack
          sx={(theme) => ({
            padding: theme.spacing(3),
            width: { xs: "100%", sm: "500px" },
          })}
        >
          <Text
            text="Onboard your system"
            sx={(theme) => ({
              color: "#DDB1FF",
              fontWeight: "500",
              mb: theme.spacing(3),
            })}
          />
          <HorizontalLinearProgressBar variant="determinate" value={100} />
        </Stack>

        <ContentCard sx={{ width: { xs: "100%", sm: "500px" } }}>
          <Stack gap={5}>
            <Text
              text={`OOOPS, Something went wrong`}
              sx={(theme) => ({
                color: theme.palette.error.main,
                fontSize: "22px",
                lineHeight: "26px",
              })}
            />

            <Stack gap={3}>
              <PrimaryButton
                text={"Return to start"}
                onClick={handleToSystemOnboarding}
              />
            </Stack>
          </Stack>
        </ContentCard>
      </Stack>
    </>
  );
};

export default OnboardingError;
